export default "__VITE_ASSET__pEg7PmrB__"